import { useEffect, useState } from "react";
import WebApp from "@twa-dev/sdk";

const THRESHOLD = 100;

export function useKeyboardOpen(): boolean {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function checkTelegram() {
      try {
        const vh = WebApp.viewportHeight;
        const stable = WebApp.viewportStableHeight;
        if (typeof vh === "number" && typeof stable === "number") {
          setOpen(stable - vh > THRESHOLD);
          return true;
        }
      } catch {
        // не в Telegram — упадём на visualViewport
      }
      return false;
    }

    function checkVisualViewport() {
      const vv = window.visualViewport;
      if (!vv) return;
      const diff = window.innerHeight - vv.height;
      setOpen(diff > THRESHOLD);
    }

    let usingTelegram = false;
    try {
      WebApp.onEvent("viewportChanged", checkTelegram);
      usingTelegram = checkTelegram();
    } catch {
      usingTelegram = false;
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", checkVisualViewport);
      if (!usingTelegram) checkVisualViewport();
    }

    return () => {
      try {
        WebApp.offEvent("viewportChanged", checkTelegram);
      } catch {
        // ignore
      }
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", checkVisualViewport);
      }
    };
  }, []);

  return open;
}
